import {
  GetIssueResponseDtoApprovalStatusEnum,
  GetIssueResponseDtoStatusEnum,
} from '@issuemanager/api-client';
import {
  IssueApprovalStatusEnum,
  IssueStatusEnum,
} from '@issuemanager/constants';

type Params = {
  status: GetIssueResponseDtoStatusEnum | undefined;
  isInitiated?: boolean;
  approvalStatus?: GetIssueResponseDtoApprovalStatusEnum | undefined;
};

export const useIssueStatusInfo = ({
  status,
  isInitiated,
  approvalStatus,
}: Params): {
  isEditable: boolean;
  isInitiated?: boolean;
  isClosedOrDiscarded: boolean;
  isNotYetAssigned: boolean;
  isReadyToApprove: boolean;
} => {
  const issueStatusDefaultValues = {
    isEditable: false,
    isInitiated: false,
    isClosedOrDiscarded: false,
    isNotYetAssigned: false,
    isReadyToApprove: false,
  };

  if (!status) {
    return issueStatusDefaultValues;
  }

  const closedOrDiscardedOptions: GetIssueResponseDtoStatusEnum[] = [
    IssueStatusEnum.CLOSED,
    IssueStatusEnum.DISCARDED,
  ];

  const isClosedOrDiscarded = closedOrDiscardedOptions.includes(status);

  if (!approvalStatus) {
    return {
      ...issueStatusDefaultValues,
      isClosedOrDiscarded,
    };
  }

  const editableOptions: GetIssueResponseDtoStatusEnum[] = [
    GetIssueResponseDtoStatusEnum.Draft,
    GetIssueResponseDtoStatusEnum.Open,
    GetIssueResponseDtoStatusEnum.InProgress,
  ];

  const isEditable = editableOptions.includes(status);

  const isNotYetAssigned = status === IssueStatusEnum.OPEN;

  const isReadyToApprove = Boolean(
    status === IssueStatusEnum.TO_BE_APPROVED &&
      approvalStatus === IssueApprovalStatusEnum.WAITING_FOR_APPROVAL,
  );

  return {
    isEditable,
    isInitiated,
    isClosedOrDiscarded,
    isNotYetAssigned,
    isReadyToApprove,
  };
};
